import React from "react";
import { Info } from "lucide-react";

// Small, consistent point-of-capture / transparency notice. Used to meet the
// UK-GDPR "be transparent at the point of collection" expectation across the
// app (photo capture, AI import, e-signing).
export function PrivacyNotice({ children, className = "", testId }) {
  return (
    <p
      className={`flex items-start gap-1.5 text-[11px] leading-snug text-slate-500 ${className}`}
      data-testid={testId || "privacy-notice"}
    >
      <Info className="mt-0.5 h-3 w-3 shrink-0 text-slate-400" />
      <span>{children}</span>
    </p>
  );
}

export default PrivacyNotice;
